import { render } from "./PledgeManagerInfoHighlightsBox.vue?vue&type=template&id=3a4f1708"
import script from "./PledgeManagerInfoHighlightsBox.vue?vue&type=script&lang=js"
export * from "./PledgeManagerInfoHighlightsBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__